import type { SelectOptionCtx } from '@cli-types/next-adapter/generators.js'
import { renderBuildSelectOptionTypesComponentTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/build-select-option-types.js'

export function buildSelectOptionTypes(ctx: SelectOptionCtx): string {
  const fieldNames = ctx.creatableSelectFields
    .map((field) => JSON.stringify(field.name))
    .join(' | ')

  return renderBuildSelectOptionTypesComponentTemplate({
    ctxSingular: ctx.Singular,
    fieldNames: fieldNames,
    ctxCamelSingular: ctx.camelSingular,
    ctxPlural: ctx.plural
  })
}
